import api from '../../api';

let cachedIdentity = null;
let pendingIdentity = null;

export const formatCompanyTaxId = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 14);
  if (!digits) return '';
  if (digits.length !== 14) return digits;
  return digits
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{2})$/, '$1-$2');
};

export const companyIdentityLine = (identity = {}) => {
  const name = String(identity?.name || '').trim();
  const taxId = formatCompanyTaxId(identity?.taxId);
  return [name, taxId ? `CNPJ: ${taxId}` : ''].filter(Boolean).join(' • ');
};

const blobToDataUrl = (blob) => new Promise((resolve) => {
  if (!blob || typeof FileReader === 'undefined') {
    resolve('');
    return;
  }
  const reader = new FileReader();
  reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
  reader.onerror = () => resolve('');
  reader.readAsDataURL(blob);
});

const loadCompanyLogoDataUrl = async (hasLogo) => {
  if (!hasLogo) return '';
  try {
    const response = await api.get('/company/logo/content', { responseType: 'blob' });
    return await blobToDataUrl(response?.data);
  } catch {
    return '';
  }
};

export const loadCompanyIdentity = async () => {
  if (cachedIdentity) return cachedIdentity;
  if (!pendingIdentity) {
    pendingIdentity = api.get('/company')
      .then(async (response) => {
        const logoUrl = String(response?.data?.logoUrl || '').trim();
        const logoDataUrl = await loadCompanyLogoDataUrl(Boolean(logoUrl));
        return {
          name: String(response?.data?.name || '').trim(),
          tradeName: String(response?.data?.tradeName || '').trim(),
          taxId: String(response?.data?.taxId || '').trim(),
          email: String(response?.data?.email || '').trim(),
          phone: String(response?.data?.phone || '').trim(),
          website: String(response?.data?.website || '').trim(),
          addressLine1: String(response?.data?.addressLine1 || '').trim(),
          addressLine2: String(response?.data?.addressLine2 || '').trim(),
          city: String(response?.data?.city || '').trim(),
          state: String(response?.data?.state || '').trim(),
          zipCode: String(response?.data?.zipCode || '').trim(),
          logoUrl,
          logoDataUrl,
        };
      })
      .catch(() => ({ name: '', tradeName: '', taxId: '', email: '', phone: '', website: '', addressLine1: '', addressLine2: '', city: '', state: '', zipCode: '', logoUrl: '', logoDataUrl: '' }))
      .then((identity) => {
        cachedIdentity = identity;
        return identity;
      })
      .finally(() => { pendingIdentity = null; });
  }
  return pendingIdentity;
};
